import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { LoanRequestsDuplicatesTableDefinitionZod, LoanRequestsTableDefinitionZod } from '../tables';
import { schemaUserResolver_GetAclPermissions } from '../../user/resolvers/getAclPermissions';

type Arguments = {
    loanRequestId: string;
    position?: number;
    limit?: number | string;
    offset?: number | string;
};

export const schemaLoanRequestResolver_GetDuplicateInfoByLead = z.array(
    LoanRequestsTableDefinitionZod.omit({ antragsteller1: true }).merge(
        z.object({
            antragsteller1: LoanRequestsTableDefinitionZod.shape.antragsteller1.unwrap(),
            duplicateMatch: LoanRequestsDuplicatesTableDefinitionZod.or(z.record(z.never())),
            permissions: schemaUserResolver_GetAclPermissions,
            schufaSummary: z.object({ schufaScore: z.string().optional() }).nullable().optional(),
        }),
    ),
);

export type SchemaLoanRequestResolver_GetDuplicateInfoByLead = z.infer<
    typeof schemaLoanRequestResolver_GetDuplicateInfoByLead
>;

export type LoanRequestResolver_GetDuplicateInfoByLead = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetDuplicateInfoByLead
>;
